module.exports = ":host ::ng-deep .errorConfirmationContent {\n  max-width: 600px; }\n\n:host ::ng-deep mat-icon {\n  font-size: 30px; }\n"